export const environment = {
  production: false,
  apiUrlLocal: 'http://localhost:3000/api/V1',
  apiUrl: 'https://fagil.api.mbt.dev.innbit.biz/api/v1',
  powerBiUrl: 'https://app.powerbi.com/view?r=eyJrIjoiZWE0NmE0MDAtNmIyMC00YmQxLTlhOGMtYTIzZmViMWI3YTI3IiwidCI6IjY4Y2MxODgxLWFhNWQtNDIxMi05NDI0LWMzZjkzYjU0Y2Y3NiIsImMiOjR9',
  powerBiUrlDSI: 'https://app.powerbi.com/reportEmbed?reportId=e334c801-6a39-433e-ace3-122c3137db10&autoAuth=true&ctid=68cc1881-aa5d-4212-9424-c3f93b54cf76',
  lambdaUrl: 'https://svovdezxzqjdd6ozh7zq6t5dei0bqlzz.lambda-url.us-east-1.on.aws/',
  azure: {
    clientId: '2c88a912-26f5-46ff-9967-78b8232ca076',
    authority: 'https://login.microsoftonline.com/6e122c06-1a92-4cd9-8bea-26bdc01d86ad',
    redirectUri: 'http://localhost:4200/',
    clientSecret: 'cd144023-a3f7-4a9a-9aa6-e194bdd11fcc',
    tenantId: '6e122c06-1a92-4cd9-8bea-26bdc01d86ad',
    postLogoutRedirectUri: 'http://localhost:4200/login',
  },
};
